import { defineAction } from '~/prix'
import familyFetchAction from './familyFetch.action.json' with { type: 'json' }
import { citizenHealthProfileShape } from '../../citizenHealthProfile/stats/citizenHealthProfileStats.definition'
import { z } from 'zod'
import expression from '~/prix/types/expression'

export const familyExpression = expression(citizenHealthProfileShape.shape)

const familyFetchDefinition = defineAction({
  ...familyFetchAction,
  input: z.object({ id: z.string().nonempty() }),
  output: z.object({
    items: z.array(citizenHealthProfileShape),
    count: z.number(),
  }),
})

export default familyFetchDefinition
